<template>
  <div class="banner">
    <div class="banner-bg" :style="bgStyle"></div>
    <div class="banner-mask"></div>
    <div class="banner-title">
      <p class="title-main">{{ title }}</p>
      <p v-if="subtitle" class="title-sub">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: ""
    }
  },
  computed: {
    bgStyle() {
      // 统一用默认头图资源，避免 require 动态路径问题
      return {
        backgroundImage: "url(" + require("../assets/img/bgtop.jpg") + ")"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 280px;
  position: relative;
  overflow: hidden;
  background-color: #0f2f4a;
}

.banner-bg {
  position: absolute;
  inset: -12px;
  background-position: center;
  background-size: cover;
  filter: blur(2px) saturate(1.05);
  transform: scale(1.04);
}

.banner-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    rgba(10, 36, 58, 0.78) 0%,
    rgba(20, 103, 159, 0.55) 55%,
    rgba(15, 47, 74, 0.45) 100%
  );
}

.banner-title {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  animation: bannerIn 0.7s ease both;
}

.title-main {
  margin: 0;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: 6px;
}

.title-sub {
  margin: 12px 0 0;
  font-size: 13px;
  letter-spacing: 3px;
  color: rgba(210, 232, 246, 0.92);
}

@media (max-width: 960px) {
  .banner {
    height: 220px;
  }

  .title-main {
    font-size: 30px;
    letter-spacing: 3px;
  }
}

@media (max-width: 640px) {
  .banner {
    height: 180px;
  }

  .title-main {
    font-size: 24px;
    letter-spacing: 2px;
    padding: 0 16px;
  }

  .title-sub {
    font-size: 12px;
    letter-spacing: 2px;
  }
}

@keyframes bannerIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
